<template>
    <div class="countdown-wrapper" v-if="ready" :style="styles">
        <span class="label" v-if="label">
            {{ label }}
        </span>
        <div class="timer">
            <div class="timer_container">
                <div class="timer-item" v-if="days > 0">
                    <span>{{ days }}</span>
                    <strong>DAYS</strong>
                </div>
                <div class="timer-item">
                    <span>{{ hours }}</span>
                    <strong>HRS</strong>
                </div>
                <div class="timer-item">
                    <span>{{ minutes }}</span>
                    <strong>MIN</strong>
                </div>
                <div class="timer-item">
                    <span>{{ seconds }}</span>
                    <strong>SEC</strong>
                </div>
            </div>
        </div>
        <div class="image" v-if="image">
            <a :href="url">
                <img :src="image" :alt="imageAlt"/>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CountDownModule',
        props: {
            config: {
                type: Object,
                required: true
            },
            image: {
                type: String,
                required: false,
                default: null
            }
        },
        computed: {
            styles() {
                const styles = {};

                if (this.config.background_color) {
                    styles.backgroundColor = this.config.background_color;
                }

                if (this.config.text_color) {
                    styles.color = this.config.text_color;
                }

                return styles;
            },
            days() {
                return this.duration.days();
            },
            hours() {
                return this.duration.hours();
            },
            minutes() {
                return this.duration.minutes()
            },
            seconds() {
                return this.duration.seconds()
            },
            duration() {
                const diff = this.timeInstance.diff(this.now);
                return this.$moment.duration(diff);
            },
            label() {
                return this.config.label || null;
            },
            imageAlt() {
                return this.config.image_alt;
            },
            url() {
                return this.config.url;
            },
            ready() {
                return this.timeInstance && this.timeInstance.diff(this.now, 'seconds') > 0;
            }
        },
        data: () => ({
            timeInstance: null,
            now: null,
        }),
        mounted() {
            this.setNow();
            this.setTimeInstance();
            setInterval(this.setNow, 1000);
        },
        methods: {
            setNow() {
                this.now = this.$moment(new Date());
            },
            setTimeInstance() {
                if (!this.config.end_time) {
                    return;
                }

                try {
                    this.timeInstance = this.$moment(this.config.end_time);
                } catch (e) {
                    console.error('Unable set the time instance for the countdown module');
                }
            }
        }
    }
</script>
